import { initializeApp } from 'firebase/app';
import { fs_db } from 'global/firestoreData/appData/fsAppData';
import { fbAppConfigs } from 'project/appConfigs';
import { _projectAppNames } from 'project/appConfiguration';
import React, { useCallback, useContext } from 'react'
import { DatabaseContext } from '../DatabaseContext';

export const useAppConfig = () => {

  const databaseContext = useContext(DatabaseContext);
  const { database_handlers } = databaseContext ?? {}

  const changeDatabase = useCallback((projectAppName) => {
    let _environment_change;

    switch (projectAppName) {
      case _projectAppNames.meetingevolution:
      case _projectAppNames.thumbstat:
      case _projectAppNames.cardnudge:
      case _projectAppNames.pojo:
        _environment_change = 'dev'
        break;
      default:
    }
    const _config_change = fbAppConfigs[projectAppName][_environment_change]
    const fsInit_change = initializeApp(_config_change, projectAppName)
    const fsdb_change = fs_db.get_fsAlt(fsInit_change)
    database_handlers.handleChange_database(fsdb_change, projectAppName)
  }, []);

  return { changeDatabase }
}
